// extracted by mini-css-extract-plugin
module.exports = {"title":"SettungsInbox_title__D58F2","alert":"SettungsInbox_alert__3XBbY"};